const getters = {
  actionPrivilege: state => state.config.actionPrivilege,
  privileges: state => state.permission.privileges,
}

export default getters
